import { render, staticRenderFns } from "./Dialog_ClassHourCart.vue?vue&type=template&id=a5964ef8&scoped=true&"
import script from "./Dialog_ClassHourCart.vue?vue&type=script&lang=js&"
export * from "./Dialog_ClassHourCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5964ef8",
  null
  
)

export default component.exports